
import type { PropOptions } from 'vue';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import CommentIcon from './images/preview-comment.vue.svg';
import type { IPost } from '@/types/community';
import BravadoText from '@/components/common/BravadoText/BravadoText.vue';
import SignUpWallLink from '@/components/common/SignUpWallLink.vue';
import WarRoomCategoryBadge from '@/components/partials/war-room/WarRoomCategoryBadge/WarRoomCategoryBadge.vue';
import WarRoomPostActions from '@/components/partials/war-room/WarRoomPostActions.vue';
import warRoomSignUpMixin from '@/components/partials/war-room/WarRoomSignUp/warRoomSignUpMixin';

export default Vue.extend({
  name: 'WarRoomPinnedPost',
  components: {
    BravadoText,
    CommentIcon,
    SignUpWallLink,
    WarRoomPostActions,
    WarRoomCategoryBadge,
  },
  mixins: [warRoomSignUpMixin],
  props: {
    post: {
      type: Object,
      required: true,
    } as PropOptions<IPost>,
  },
  computed: {
    ...mapGetters('warRoom', ['isAdmin']),
    link(): string {
      return `${this.$pages.POSTS_PAGE.path}/${this.post.slug}`;
    },
  },
});
